import { create } from 'zustand';

type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastAction {
  label: string;
  onClick: () => void;
}

interface ShowToastOptions {
  message: string;
  type?: ToastType;
  action?: ToastAction;
  /** Keep the toast up until hideToast is called, for work that outlasts the default. */
  persist?: boolean;
}

interface ToastState {
  open: boolean;
  message: string;
  type: ToastType;
  action?: ToastAction;
  /** Milliseconds before the toast hides itself; undefined keeps it up until hideToast is called. */
  autoHideMs?: number;
  showToast: (options: ShowToastOptions) => void;
  hideToast: () => void;
}

const DEFAULT_AUTO_HIDE_MS = 6000;

export const useToast = create<ToastState>(set => ({
  open: false,
  message: '',
  type: 'info',
  action: undefined,
  autoHideMs: DEFAULT_AUTO_HIDE_MS,
  showToast: ({ message, type, action, persist }: ShowToastOptions) => {
    set({ open: true, message, type, action, autoHideMs: persist ? undefined : DEFAULT_AUTO_HIDE_MS });
  },
  hideToast: () => set({ open: false, action: undefined, autoHideMs: DEFAULT_AUTO_HIDE_MS }),
}));
